export enum UpcomingChangeType {
  BACKUP = 'BACKUP',
  REPLACEMENT = 'REPLACEMENT',
}

export enum UpcomingChangeStatus {
  PENDING = 'PENDING',
  ASSIGNED = 'ASSIGNED',
  // TODO: remove comment lines after backend update
  // CANCELLED = 'CANCELLED',
  // FAILED = 'FAILED',
  // COMPLETED = 'COMPLETED',
}

export const UPCOMING_CHANGE_STATUS_OPTIONS = {
  [UpcomingChangeStatus.PENDING]: 'Pending',
  [UpcomingChangeStatus.ASSIGNED]: 'Assigned',
  // TODO: remove comment lines after backend update
  // [UpcomingChangeStatus.CANCELLED]: 'Cancelled',
  // [UpcomingChangeStatus.FAILED]: 'Failed',
  // [UpcomingChangeStatus.COMPLETED]: 'Completed',
};
